export function FormatDate(date: { getFullYear: () => string; getMonth: () => number; getDate: () => number; }) {
  const year: string = date.getFullYear();
  const month: string = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
  const day: string = (date.getDate() < 10 ? '0' : '') + date.getDate();
  return `${year}-${month}-${day}`;
}